import * as React from 'react';
import upNext, { UpNextProps } from '../../custom/components/up-next';

const UpNextView: React.StatelessComponent<UpNextProps> = props => {
    
    if (props.upNext) {
        return (         
            <article className={`ace-cal-upnext-container adage-listing-item adage-themed adage-listing-item-flipped ${props.upNext.pageTheme}`}> 
                <div className="adage-listing-item-inner">
                    <div className="adage-listing-item-content">
                        {/* Title */}
                        <h2 className="adage-listing-item-heading">
                            {props.upNext.name}
                        </h2>
                        <div className="adage-listing-item-wysiwyg rich-text">
                            {/* Description */}
                            <div dangerouslySetInnerHTML={{ __html: props.upNext.synopsis }} />

                            {/* Link */}
                            {props.upNext.viewDetailCtaUrl && (
                                <div className={`adage-block-level-cta adage-listing-cta ${props.upNext.viewDetailCtaUrl ? null : "epi-empty-link"}`}>
                                    <a href={props.upNext.viewDetailCtaUrl} className="arrow-link">{props.upNext.viewDetailCtaText}</a>
                                </div>  
                            )}
                        </div>
                    </div>
                </div>
            </article>           
        );
    } else {
        return null;
    }
}

export default UpNextView;